export default class pegCookiebanner extends HTMLElement {
	connectedCallback() {
		this.#setCookieIfUserIsAlreadyRegistered();
		this.#createMarkup();
		this.#init();
	}

	disconnectedCallback() {}

	#createMarkup() {
		const template = document.createElement('template');
		const shadowHtml = `<style>
					:host {
						display: none;
					}

					:host([open]) {
						container-type: inline-size;
						container-name: cookieBanner;
						display: flex;
						position: fixed;
						bottom: 0;
						left: 0;
						right: 0;
						z-index: 999;
						--COLOR_text: var(--COLOR_support_white_default);
						--COLOR_background: var(--COLOR_primary_default);
					}

					:host([brand="elitepartner"]) .inner {
						@container cookieBanner (min-width: 768px) {
							--COLOR_text: var(--COLOR_gray_200);
							--COLOR_background: var(--COLOR_support_white_default);
						}
					}

					:host([open]) .inner {
						display: flex;
						font-family: 'Open Sans', Arial, Helvetica, sans-serif;
						line-height: 14px;
						font-weight: normal;
						align-items: flex-start;
						padding: 10px 110px 10px 20px;
						width: 100%;
						max-height: 200px;
						overflow: auto;
						-webkit-overflow-scrolling: touch;
						font-size: 11px;
						border-top: 1px solid rgba(255,255,255, .2);
						background-color: var(--COLOR_background);
						color: var(--COLOR_text);
					}

					:host .inner span {
						padding: 6px 0 4px 0;
					}

					:host .inner a {
						color: var(--COLOR_text);
						text-decoration: underline;
						
						&:focus-visible {
							outline: 2px dashed currentColor;
							outline-offset: 2px;
						}
					}

					:host .inner button {
						position: fixed;
						right: 0;
						max-width: 80px;
						margin: 10px 20px 0 0;
						padding: 8px 12px;
						border: 2px solid var(--COLOR_text);
						color: var(--COLOR_text);
						border-radius: 4px; /* lokaler radius */
						text-decoration: none;
						text-align: center;
						font-weight: 600;
						font-size: 13px;
						z-index: 1000;
						background: none;
						cursor: pointer;
						
						&:focus-visible {
							outline: 2px dashed currentColor;
							outline-offset: 2px;
						}
					}
				</style>
				<div class="inner">
					<span data-target="bannertext"></span>
					<button></button>
				</div>
			`;

		template.innerHTML = this.#sanitizeEvilHtml(shadowHtml);

		const clone = document.importNode(template.content, true);
		if (!this.shadowRoot) {
			this.attachShadow({ mode: 'open' });
			this.shadowRoot.appendChild(clone);
		}
	}

	#init() {
		const showBanner = getCookie('tms_infobanner') === null;
		if (showBanner) {
			this.setAttribute('open', '');
			this.shadowRoot.querySelector('[data-target="bannertext"]').innerHTML = this.#sanitizeEvilHtml(
				this.querySelector('[data-role="bannertext"]').innerHTML,
			);
			this.shadowRoot.querySelector('button').innerText = this.querySelector('[data-role="buttontext"]').innerText;

			this.querySelector('[data-role="bannertext"]').remove();
			this.querySelector('[data-role="buttontext"]').remove();
			this.#trackBannerIsShown();

			this.shadowRoot.querySelector('button').addEventListener(
				'click',
				() => {
					this.#setDismissCookie();
					this.#trackClickedOk();
					this.remove();
				},
				{ once: true },
			);
		}
	}

	#setCookieIfUserIsAlreadyRegistered() {
		const isLoggedIn = this.getAttribute('is-loggedin') === 'true';
		if (isLoggedIn) {
			this.#setDismissCookie();
		}
	}

	#setDismissCookie() {
		setCookie('tms_infobanner', 'dismiss', '760');
	}

	#sanitizeEvilHtml(string) {
		// Das muss nochmal ein richtiger sanatizer werden
		return String(string).replace(
			/<script\b|\bonerror=|\bonload=|\bonmouseover=|\bonmouseout=|\bonpagehide=|\bonpageshow=|\bonmessage=|\bonhashchange=|\bonbeforeunload=|\bonpopstate=|\bonresize=|\bonunload=|\bonkeydown=|\bonkeyup=|\bonkeypress=|\bonfocus=|\bonblur=|\bonchange=|\bonsubmit=|\bonreset=|\bonselect=|\bondblclick=|\bondrag=|\bondragend=|\bondragenter=|\bondragleave=|\bondragover=|\bondragstart=|\bondrop=|\bonwheel=|\boncopy=|\boncut=|\bonpaste=|\bonanimationend=|\bonanimationiteration=|\bonanimationstart=|\bontransitionend=|\bontouchcancel=|\bontouchend=|\bontouchmove=|\bontouchstart=|\bonclick=/gi,
			'',
		);
	}

	#trackBannerIsShown() {
		document.dispatchEvent(
			new CustomEvent('pegLogger-logWebAppEvents', {
				detail: {
					// Do not use jPar.wdk.logger.bigData here. Component is in base_combined, we don't have jPar yet.
					category: 'tracking_choice',
					subcategory: 'tracking_choice_dialog',
					targetId: 'dialog',
					action: 'show',
				},
			}),
		);
	}

	#trackClickedOk() {
		// OptOut
		document.dispatchEvent(
			new CustomEvent('pegLogger-logWebAppEvents', {
				detail: {
					category: 'tracking_choice',
					subcategory: 'tracking_choice_dialog',
					targetId: 'ok_button',
					action: 'click',
				},
			}),
		);
	}
}
